(function($){
    $(function(){ 

        $('a.enduroempire-popup.priceMatch').click(function(){
    $('div#saleNotify').hide();
  $('div#priceMatch').show();
    $('div#priceMatch').removeClass('mfp-hide enduroempire-dialog-main');
   $('body').addClass('custom-pop-product');
$('div#priceMatch').addClass('mfp-fade enduroempire-dialog');
    $('div#priceMatch .dialog-content').after('<button title="Close (Esc)" type="button" class="mfp-close">×</button>');
});


$('a.enduroempire-popup.saleNotify').click(function(){
  $('body').addClass('custom-pop-product');
    $('div#priceMatch').hide();
  $('div#saleNotify').show();
    $('div#saleNotify').removeClass('mfp-hide enduroempire-dialog-main');
$('div#saleNotify').addClass('mfp-fade enduroempire-dialog');
    $('div#saleNotify .dialog-content').after('<button title="Close (Esc)" type="button" class="mfp-close">×</button>');
});
      $(document).on('click', 'button.mfp-close', function() {
        
         $('body').removeClass('custom-pop-product');
    $('div#saleNotify').hide();
$('div#priceMatch').hide();
      
      });

    });

   

})(jQuery);






